import {inject, TemplateRef} from '@angular/core';

export class ContentTemplateDirective {
  readonly template = inject(TemplateRef<any>, { optional: false })
}
